// extracted by mini-css-extract-plugin
export var acitonButtons = "_gk-0";
export var additionalIcon = "_gk-f";
export var block = "_gk-1";
export var blockContent = "_gk-7";
export var blockDescription = "_gk-8";
export var blockIcon = "_gk-9";
export var blockTitle = "_gk-6";
export var border = "_gk-a";
export var center = "_gk-l";
export var edge = "_gk-b";
export var edgeLabel = "_gk-c";
export var edgePath = "_gk-d";
export var error = "_gk-e";
export var flowchart = "_gk-g";
export var flowchartContent = "_gk-h";
export var highlighted = "_gk-3";
export var hover = "_gk-4";
export var icon = "_gk-i";
export var left = "_gk-m";
export var navButton = "_gk-j";
export var navButtons = "_gk-k";
export var right = "_gk-n";
export var selected = "_gk-2";
export var small = "_gk-5";